export default __webpack_public_path__ + "static/media/bubble_nova_background_m1.e70ee62c.jpg";